const AppointmentForm = () => {
    return (
        <div className="appointment-content">
            <div className="academic-notice-board">
                <div className="notice-header">
                    <div className="notice-header__text">
                        <h2 className="notice-title">Notice &amp; Hours</h2>
                        <span className="notice-label">Clinic Information</span>
                    </div>
                    <a
                        href="https://m.booking.naver.com/booking/13/bizes/1581590?theme=place&service-target=map-pc&lang=ko"
                        className="btn btn-naver"
                    >
                        <span className="btn-naver__mark">N</span>
                        네이버 예약하기
                    </a>
                </div>

                <div className="notice-content-wrap">
                    {/* 예약 안내 — 시술 상담 전용 */}
                    <div className="notice-section">
                        <h6 className="section-title">예약 안내 <span>(시술 상담 전용)</span></h6>
                        <div className="section-body">
                            <p>
                                토닝(기미·흑자·잡티) · 흉터 · 리프팅 · 보톡스 · 필러 · 스킨부스터
                                <strong> 상담</strong>만 네이버 예약이 가능합니다.
                            </p>
                            <p className="muted">일반 진료는 예약이 불가하며, 당일 현장 접수만 가능합니다.</p>
                        </div>
                    </div>

                    {/* 진료 시간 및 접수 안내 */}
                    <div className="notice-section">
                        <h6 className="section-title">진료 시간</h6>
                        <div className="section-body">
                            <ul className="hours-list">
                                <li>
                                    <span className="day">월 · 화 · 목 · 금</span>
                                    <span className="hours">06:30 – 15:30</span>
                                    <span className="note">접수 마감은 보통 종료 2시간 전보다 일찍 마감됩니다.</span>
                                </li>
                                <li>
                                    <span className="day">토요일</span>
                                    <span className="hours">05:30 – 10:30</span>
                                    <span className="note">접수 마감은 보통 오전 7:30 전후입니다.</span>
                                </li>
                                <li>
                                    <span className="day">수요일 · 일요일</span>
                                    <span className="hours muted">휴진</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="notice-footer">
                    <p>재진 예약은 현장에서 관리 받으시는 분들에 한해 안내해 드리고 있습니다.</p>
                    <p>현재 카카오톡 및 전화 예약은 운영하지 않습니다.</p>
                </div>
            </div>
        </div>
    );
};

export default AppointmentForm;
